<script setup>
import backgroundImage from '@/assets/about/background.png';

</script>



<template>
  <div class="landingImage">
    <div class="container hero-container items-center flex flex-col h-full justify-center">
      <div class="responsive-title-1 mb-6 ml-3 text-center font-thin">
        About us
      </div>
      <p class="text-center responsive-body-xlarge font-semibold">Who we are</p>
    </div>
  </div>


</template>




<style scoped>
.landingImage {
  background-image: linear-gradient(to bottom, rgba(16, 10, 53, 0.7), rgba(16, 10, 53, 0)),
  url(@/assets/about/about_us.jpg);
  background-size: cover;
  object-fit: contain;
  background-position: center;
  background-attachment: fixed;
  height: 90vh;
  max-height: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}



@media (max-width: 768px) {
  .landingImage {
    max-height: 474px;
    background-position: center;
  }
}


</style>
